import { v4 as uuid } from 'uuid';
import { some } from 'lodash';

import { useMutation } from '../../index';
import { useUserContext } from '@ion/user';
import { query } from '../useQueryIntegrations';
import permissions from '../../Apollo/permissions';
import { validate } from 'parameter-validator';

import { mutation as cloneMutation, buildVariables as buildCloneVariables } from './clone-integration-mutation-builder';

export default function useCloneIntegration(options = {}) {
  const { user, currentOrg } = useUserContext();
  const userData = { email: user?.email, org: currentOrg?.display_name };

  const [executeCloneMutation, response] = useMutation(cloneMutation, {
    context: { permission: permissions.createIntegration },
    ...options,
    update: buildUpdateCache(),
  });

  const cloneIntegration = async args => {
    const { newName, starterkitId, starterkitVersion, playbooks } = validate(args, [
      'newName',
      'starterkitId',
      'starterkitVersion',
      'playbooks',
    ]);

    const newIntegrationId = uuid();

    const result = await executeCloneMutation({
      variables: buildCloneVariables({
        newIntegrationId,
        newName,
        starterkitId,
        starterkitVersion,
        playbooks,
      }),
    });

    if (result.data?.insert_integrations_one) {
      track({ newIntegration: result.data.insert_integrations_one, userData });
    }

    return result;
  };

  return [cloneIntegration, response];
}

function buildUpdateCache() {
  return (cache, { data }) => {
    try {
      const newIntegration = data.insert_integrations_one;

      const { integrations } = cache.readQuery({ query }) || [];

      if (!integrations) return;

      if (some(integrations, integration => integration.id === newIntegration.id)) {
        return;
      }

      cache.writeQuery({
        query,
        data: {
          integrations: [newIntegration, ...integrations],
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
}

function track({ newIntegration, userData }) {
  __mrTracking?.track('integration_cloned', {
    id: newIntegration.id,
    name: newIntegration.name,
    starterkitId: newIntegration.starterkitId,
    starterkitVersion: newIntegration.starterkitVersion,
    userEmail: userData.email,
    orgName: userData.org,
  });
}
